import { render } from "./FAQCategoryIcon.vue?vue&type=template&id=4e28ad2c&scoped=true"
import script from "./FAQCategoryIcon.vue?vue&type=script&lang=js"
export * from "./FAQCategoryIcon.vue?vue&type=script&lang=js"

import "./FAQCategoryIcon.vue?vue&type=style&index=0&id=4e28ad2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e28ad2c"]])

export default __exports__